import { Injectable, inject } from '@angular/core'
import { Action, Store } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

@Injectable({ providedIn: 'root' })
export class SearchHistoryFacade implements GbBaseFacade {
  private readonly store = inject(Store)

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
